import React, { useState, useEffect } from "react"
import { StaticQuery, graphql } from "gatsby"
import { useCookies } from "react-cookie"
import styled from "styled-components"
import { useLocation } from "@reach/router"
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies"
import Card from "../Card"
import SecondaryBtn from "../Buttons/SecondaryBtn"
import breakpoints from "../../styles/breakpoints"
import { CloseIcon, CookieIcon } from "../Icons"
import localeData from "../../locale"

const CookiesContainer = styled(Card)`
  display: ${(props) => (props.showContainer ? "flex" : "none")};
  position: fixed;
  padding: 16px;
  bottom: 16px;
  right: 16px;
  left: 16px;
  z-index: 998;
  box-shadow: ${(props) => props.theme.boxShadow.zIndex5};
  button {
    margin-top: 16px;
    display: block;
  }

  ${breakpoints.md`
    padding: 24px;
    max-width: 384px;
    bottom: 48px;
    right: 48px;
    left: unset;
    button {
      display: inline-block;
      margin-right: 16px;
    }
  `};
`

const CookiesSettingsBtn = styled(Card)`
  display: ${(props) => (props.showButton ? "flex" : "none")};
  position: fixed;
  z-index: 997;
  box-shadow: ${(props) => props.theme.boxShadow.zIndex5};

  padding: 8px;
  bottom: 16px;
  right: 16px;
  left: unset;
  button {
    display: inline-block;
    margin-right: 16px;
  }

  &:hover {
    cursor: pointer;
  }
`
const Column = styled.div`
  svg {
    margin-right: 16px;
  }
`

const CloseButton = styled.div`
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
`

const Cookies = ({ locale, header, content }) => {
  const location = useLocation()

  const [cookies, setCookie] = useCookies([
    "gatsby-gdpr-google-analytics",
    "gatsby-gdpr-facebook-pixel",
  ])
  const [showCookie, setShowCookie] = useState(false)
  const [showSettingsBtn, setShowSettingsBtn] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const allowTracking = () => {
    setCookie("gatsby-gdpr-google-analytics", "true", { path: "/" })
    setCookie("gatsby-gdpr-facebook-pixel", "true", { path: "/" })
    initializeAndTrack(location)
    setShowCookie(false)
    setShowSettingsBtn(true)
  }

  const removeTracking = () => {
    setCookie("gatsby-gdpr-google-analytics", "false", { path: "/" })
    setCookie("gatsby-gdpr-facebook-pixel", "false", { path: "/" })
    setShowCookie(false)
    setShowSettingsBtn(false)
    setShowSettings(false)
  }

  useEffect(() => {
    if (
      typeof cookies["gatsby-gdpr-google-analytics"] === "undefined" ||
      (cookies["gatsby-gdpr-google-analytics"] !== "true" &&
        typeof cookies["gatsby-gdpr-facebook-pixel"] === "undefined") ||
      cookies["gatsby-gdpr-facebook-pixel"] !== "true"
    ) {
      setShowCookie(true)
    } else {
      setShowSettingsBtn(true)
    }
  }, [])
  return (
    <>
      <CookiesContainer showContainer={showCookie}>
        <Column>
          <CookieIcon />
        </Column>
        <Column>
          <CloseButton onClick={() => setShowCookie(false)}>
            <CloseIcon />
          </CloseButton>
          <strong>{header[locale]}</strong>
          <p>{content[locale]}</p>
          <SecondaryBtn onClick={allowTracking}>
            {localeData._rawCookiesBtn[locale]}
          </SecondaryBtn>
        </Column>
      </CookiesContainer>
      <CookiesContainer showContainer={showSettings}>
        <Column>
          <CookieIcon />
        </Column>
        <Column>
          <CloseButton onClick={() => setShowSettings(false)}>
            <CloseIcon />
          </CloseButton>
          <p>{content[locale]}</p>
          <SecondaryBtn onClick={removeTracking}>
            {localeData._rawCookiesDeclineBtn[locale]}
          </SecondaryBtn>
        </Column>
      </CookiesContainer>
      <CookiesSettingsBtn
        showButton={showSettingsBtn}
        onClick={() => setShowSettings(true)}
      >
        <CookieIcon height="20" width="20" />
      </CookiesSettingsBtn>
    </>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query cookiesContent {
        sanitySiteSettings {
          header: _rawCookiesHeader
          content: _rawCookiesText
        }
      }
    `}
    render={(data) => (
      <Cookies
        header={data.sanitySiteSettings.header}
        content={data.sanitySiteSettings.content}
        {...props}
      />
    )}
  />
)
